import styled from "styled-components";

export const Form = styled.form`
  width: 90%;
  max-width: 26rem;
  background-color: var(--color-gray-1);
  padding: 2.625rem 1.25rem;
  border-radius: var(--bd-radius);
`;
